import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { TranslationService } from '../../shared/translation.service';
import { LpConstants } from '../../shared/types/lp-constants';
import { WindowService } from '../../shared/window.service';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { GTMService } from '../../shared/gtm.service';
import { UtilsService } from '../../shared/utils.service';
import { IFrameSizeEventType } from '../../shared/types/iframe-event-type';

export enum StudyPlanEvents {
  STUDY_PLAN_SAVED = 'study_plan_saved',
  STUDY_PLAN_CONTINUE = 'study_plan_continue',
  STUDY_PLAN_BACK = 'study_plan_back',
}

enum BeforeunloadEvents {
  SHOULD_REMOVE = 'should_remove_beforeunload',
  REMOVED = 'removed_beforeunload'
}

const OFFSET_HEIGHT = 68;

@Component({
  selector: 'lp2-placement-quiz-page',
  templateUrl: './placement-quiz-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlacementQuizPageComponent implements OnInit {
  @ViewChild('iframe') iframe: ElementRef<HTMLIFrameElement>;
  placementQuizUrl: string;
  beforeUnloadFn: any;
  constructor(
    private oeApp: OeAppService,
    private windowService: WindowService,
    private oeAppPersonService: OeAppPersonService,
    private translationService: TranslationService,
    private gtmService: GTMService
  ) { }


  ngOnInit() {
    window.addEventListener('message', this.handleEvents.bind(this), false);
    this.addBeforeUnloadListener();
    if (this.oeAppPersonService.oePlacementTestTaken) {
      this.windowService.redirectToHref(LpConstants.STUDY_BUNDLE_URL)
    }
    this.setPlacementQuizUrl();
  }

  private setPlacementQuizUrl() {
    const lp2LearnosityUiHost = this.oeApp.lp2LearnosityUiHost;
    const preferredLanguageIsoCode = this.oeAppPersonService.preferredLang;
    const isLfa = this.oeAppPersonService.isLfa;
    const isB2b = this.oeAppPersonService.isB2bStudent();
    this.placementQuizUrl =
      lp2LearnosityUiHost +
      '/placement-quiz' +
      '?lang=' +
      preferredLanguageIsoCode +
      '&isLfa=' +
      isLfa +
      '&isB2b=' +
      isB2b + 
      '&successUrl=' +
      window.location.origin +
      LpConstants.STUDY_BUNDLE_URL;
  }

  private addBeforeUnloadListener() {
    this.beforeUnloadFn = (event) => {
      event.returnValue = this.translationService.translate('placement_quiz.leave.warning');
    }
    window.addEventListener('beforeunload', this.beforeUnloadFn);
  }

  private removeBeforeUnloadListener() {
    window.removeEventListener('beforeunload', this.beforeUnloadFn);
  }

  private handleEvents({ data, origin, source }) {
    if (isIFrameSameOrigin(window.location.href, origin)) {
      return;
    }
  
    if (UtilsService.objectValues(StudyPlanEvents).includes(data.type)) {
      this.gtmService.sendGA4Event(data.type);
      if (data.type === StudyPlanEvents.STUDY_PLAN_SAVED) {
       this.removeBeforeUnloadListener();
       source.postMessage({ type: BeforeunloadEvents.REMOVED }, origin);
      }
    }
  
    if (data.type === IFrameSizeEventType.HEIGHT) {
      this.iframe.nativeElement.height = data.height + OFFSET_HEIGHT;
    }
  
    if (data.type === BeforeunloadEvents.SHOULD_REMOVE) {
      this.removeBeforeUnloadListener();
      source.postMessage({ type: BeforeunloadEvents.REMOVED }, origin);
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/placement-quiz/placement-quiz-page/placement-quiz-page.component.ts